import { Injectable } from "@angular/core";
import { BaseRequestOptions, Headers } from "@angular/http";
import { sha256 } from "sha256";
import { config } from "../../../config/str";

// let theToken  = sha256(config.secret);

@Injectable()
export class DefaultRequestOptions extends BaseRequestOptions{



  headers = new Headers({
    'Accept': 'application/json',
    'X-Requested-By':'SRVPLS',
    'x-access-token': '6453dcaad5a6c2e667f0cb95738a1e186ee2cb92f1ead42e86761b5d377726b1'
  });



}






// WEBPACK FOOTER //
// ./src/app/shared/services/stripe/default-request-options.ts